export default {
    environment: "prod",
    auth_server_url: "https://auth.spi3pl-tech.com/api/v1"
}